import appContext from './appContext';

// Configures the webpack root path context on the fly for any images or dynamic imports in the project
//  see: https://webpack.js.org/guides/public-path#on-the-fly
// eslint-disable-next-line
__webpack_public_path__ = `${appContext}/js/`;
